// extracted by mini-css-extract-plugin
export default {"h":"styles_h__dZqFL","p":"styles_p__mNsLI","box":"styles_box__Rni+T"};